import * as React from 'react';

import Map, { MapProps } from './Map';
import { MapEvent } from '~/config/map';

export interface MapWrapperProps extends MapProps {
  onMapLoaded?: (map: MapPostEventWrapper) => void;
}

class MapPostEventWrapper extends React.Component<MapWrapperProps> {
  map = React.createRef<HTMLIFrameElement>();
  listeners: any[] = [];
  mapping: any[] = [];
  initialised: boolean = false;

  queue: [MapEvent, any][] = [];

  sendEvent = (type: MapEvent, payload?: any) => {
    if (!this.initialised) {
      this.queue.push([type, payload]);
      return;
    }
    try {
      this.map.current?.contentWindow?.postMessage(JSON.stringify({ type, payload }), '*');
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.listenToEvent(MapEvent.AppInitialised, () => {
      this.initialised = true;
      if (this.queue.length) {
        this.queue.forEach(([type, payload]) => {
          this.sendEvent(type, payload);
        });
        this.queue = [];
      }
    });
    this.listenToEvent(MapEvent.MapInitialised, () => {
      if (this.props.onMapLoaded) this.props.onMapLoaded(this);
    });
    window.addEventListener('message', this.handleMessageReceive);
  }
  componentWillUnmount(): void {
    window.removeEventListener('message', this.handleMessageReceive);
  }

  listenToEvent(type: MapEvent, cb: (payload: any) => void) {
    const listener = (eventType: MapEvent, payload: any) => {
      if (eventType === type) {
        cb(payload);
      }
    };
    this.mapping.push(cb);
    this.listeners.push(listener);
  }

  removeEventListener(cb: (payload: any) => void) {
    const index = this.mapping.findIndex((m) => m === cb);
    if (index === -1) {
      return;
    }
    this.listeners.splice(index, 1);
    this.mapping.splice(index, 1);
  }
  handleMessageReceive = (event: MessageEvent<any>) => {
    if (typeof event.data !== 'string') {
      return;
    }
    const dataParsed = JSON.parse(event.data);
    this.listeners.forEach((listener) => {
      listener(dataParsed.type, dataParsed.payload);
    });
  };

  render() {
    return <Map ref={this.map} {...this.props} />;
  }
}
export default MapPostEventWrapper;
